export default __webpack_public_path__ + "static/media/chevrons-down.d4988fbe.svg";